import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { deleteCurrentNotificationDevice } from "src/helpers/notifications";
import { logoutUser } from "src/helpers/session";
import { buildRoute } from "../router/router";
import useHilosStore from "./useHilosStore";
import { clearMigrationModalTimestamp } from "./useMigrationModal";

function useUser() {
  const navigate = useNavigate();
  const { session, resetSession } = useHilosStore();

  const logout = useCallback(async () => {
    if (session) {
      await deleteCurrentNotificationDevice();
      logoutUser();
      resetSession();
      clearMigrationModalTimestamp();
      navigate(buildRoute("login"));
    }
  }, [navigate, session, resetSession]);

  return { logout };
}

export default useUser;
